import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { FEATURES } from '@Constants/rx-ui/constants';
import Auth from '@Services/Auth';
import IntegratedFeedbackContainer from '@Components/IntegratedFeedback/IntegratedFeedbackContainer';
import useSummaryAvailable from '@Containers/Summary/hooks/useSummaryAvailable';

/**
 * Renders the IntegratedFeedbackContainer in either a "top" or "bottom"
 * placement based on feature flags. Encapsulates the complex flag logic
 * that was previously duplicated in ResultsPage.
 */
export default function IntegratedFeedbackSlot({ placement, searchType, activeBreadcrumb }) {
  const [hidden, setHidden] = useState(false);

  const currentUser = (Auth && Auth.getUser()) || {};
  const { isSummaryAvailable } = useSummaryAvailable({ activeBreadcrumb });
  const disabledTracking = get(currentUser, 'details.disableTracking', {});

  const enabled = Auth.isFeatureEnabled(FEATURES.enableIntegratedFeedback) && !disabledTracking.INTEGRATED_FEEDBACK && !isSummaryAvailable;
  const bottom = Auth.isFeatureEnabled(FEATURES.bottomIntegratedFeedback);
  const both = Auth.isFeatureEnabled(FEATURES.topAndBottomIntegratedFeedback);

  if (hidden || !enabled) return null;

  const showAtTop = placement === 'top' && (both || !bottom);
  const showAtBottom = placement === 'bottom' && (both || bottom);

  if (!showAtTop && !showAtBottom) return null;

  return <IntegratedFeedbackContainer searchType={searchType} onHide={setHidden} />;
}

IntegratedFeedbackSlot.propTypes = {
  placement: PropTypes.oneOf(['top', 'bottom']).isRequired,
  searchType: PropTypes.string,
  activeBreadcrumb: PropTypes.object,
};
